import { Container, Form, Title } from "./style";
import { Checkbox, Error } from "../../styles/global";
import Email from "../../components/Email";
import Options from "../../components/Options";
import Button from "../../components/Button";
import { useEffect } from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import TagManager from "react-gtm-module";

import { schema } from "./validations";
import HiddenInputs from "../../components/HiddenInputs";

const DescriptiveQuestions = ({ email, setEmail }) => {
  const url = "https://kenzie39049.activehosted.com/proc.php";

  const { errors, register, setError, clearErrors, watch } = useForm({
    resolver: yupResolver(schema),
  });

  const MANDATORY_FIELD_ERROR = "Preencha esse campo obrigatório.";

  useEffect(() => {
    TagManager.dataLayer({
      dataLayer: { event: "lead-inscricao" },
    });
  });

  const areWorking = watch(["field[42]"])["field[42]"];
  const homeIncome = watch(["field[43]"])["field[43]"];
  const financial = watch(["field[44]"])["field[44]"];
  const howToStay = watch(["field[51]"])["field[51]"];
  const family = watch(["field[46]"])["field[46]"];

  const validateEmail = /^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/g;

  const submitData = (e) => {
    if (
      areWorking === null ||
      homeIncome === null ||
      financial === null ||
      howToStay === null ||
      family === null ||
      email === "" ||
      !validateEmail.test(email)
    ) {
      e.preventDefault();

      if (validateEmail.test(email) === false) {
        setError("email", {
          message: "O e-mail deve ser formatado corretamente",
        });
      }

      if (email === "") {
        setError("email", { message: MANDATORY_FIELD_ERROR });
      }

      if (areWorking === null) {
        setError("areWorking", { message: MANDATORY_FIELD_ERROR });
      }

      if (homeIncome === null) {
        setError("homeIncome", { message: MANDATORY_FIELD_ERROR });
      }

      if (financial === null) {
        setError("financial", { message: MANDATORY_FIELD_ERROR });
      }

      if (howToStay === null) {
        setError("howToStay", { message: MANDATORY_FIELD_ERROR });
      }

      if (family === null) {
        setError("family", { message: MANDATORY_FIELD_ERROR });
      }

      return false;
    }

    localStorage.setItem("email", email);
    return true;
  };

  useEffect(() => {
    if (areWorking !== null) {
      clearErrors("areWorking");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [areWorking]);

  useEffect(() => {
    if (homeIncome !== null) {
      clearErrors("homeIncome");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [homeIncome]);

  useEffect(() => {
    if (financial !== null) {
      clearErrors("financial");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [financial]);

  useEffect(() => {
    if (howToStay !== null) {
      clearErrors("howToStay");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [howToStay]);

  useEffect(() => {
    if (family !== null) {
      clearErrors("family");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [family]);

  useEffect(() => {
    if (email !== "") {
      clearErrors("email");
    }

    if (validateEmail.test(email)) {
      clearErrors("email");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [email]);

  return (
    <>
      <Container id="main">
        <Form onSubmit={submitData} method="POST" action={url} validate>
          <HiddenInputs formId={159} />

          <Email
            error={errors.email?.message}
            inputRef={register}
            name="email"
            value={email}
            onChange={setEmail}
          />

          <Title>Agora queremos saber um pouco sobre seu dia-a-dia</Title>

          <Options>
            <legend>Atualmente, você está trabalhando?</legend>

            <Checkbox>
              <label>
                <input
                  type="radio"
                  ref={register}
                  name="field[42]"
                  value="Sim, registrado em CLT"
                />
                Sim, registrado em CLT
              </label>
            </Checkbox>
            <Checkbox>
              <label>
                <input
                  type="radio"
                  ref={register}
                  name="field[42]"
                  value="Sim, trabalhando como Pessoa Jurídica (PJ)"
                />
                Sim, trabalhando como Pessoa Jurídica (PJ)
              </label>
            </Checkbox>
            <Checkbox>
              <label>
                <input
                  type="radio"
                  ref={register}
                  name="field[42]"
                  value="Sim, sou autônomo"
                />
                Sim, sou autônomo
              </label>
            </Checkbox>
            <Checkbox>
              <label>
                <input
                  type="radio"
                  ref={register}
                  name="field[42]"
                  value="Não, mas faço trabalhos temporários"
                />
                Não, mas faço trabalhos temporários
              </label>
            </Checkbox>
            <Checkbox>
              <label>
                <input
                  type="radio"
                  ref={register}
                  name="field[42]"
                  value="Não, estou desempregado"
                />
                Não, estou desempregado
              </label>
            </Checkbox>

            <Error>{errors.areWorking?.message}</Error>
          </Options>

          <Options>
            <legend>
              Atualmente, você participa ativamente da renda da casa?
            </legend>

            <Checkbox>
              <label>
                <input
                  type="radio"
                  ref={register}
                  name="field[43]"
                  value="Sim"
                />
                Sim
              </label>
            </Checkbox>
            <Checkbox>
              <label>
                <input
                  type="radio"
                  ref={register}
                  name="field[43]"
                  value="Não"
                />
                Não
              </label>
            </Checkbox>

            <Error>{errors.homeIncome?.message}</Error>
          </Options>

          <Options>
            <legend>
              Para manter financeiramente a casa, como será no período do curso?
            </legend>

            <Checkbox>
              <label>
                <input
                  type="radio"
                  ref={register}
                  name="field[44]"
                  value="Familiares tem renda fixa e suficiente para manter a casa"
                />
                Familiares tem renda fixa e suficiente para manter a casa
              </label>
            </Checkbox>
            <Checkbox>
              <label>
                <input
                  type="radio"
                  ref={register}
                  name="field[44]"
                  value="Familiares tem renda variável e suficiente para manter a casa"
                />
                Familiares tem renda variável e suficiente para manter a casa
              </label>
            </Checkbox>
            <Checkbox>
              <label>
                <input
                  type="radio"
                  ref={register}
                  name="field[44]"
                  value="Familiares tem renda Fixa/Variável, insuficiente para manter a
                casa"
                />
                Familiares tem renda Fixa/Variável, insuficiente para manter a
                casa
              </label>
            </Checkbox>
            <Checkbox>
              <label>
                <input
                  type="radio"
                  ref={register}
                  name="field[44]"
                  value="Possui uma reserva financeira para mais de 12 meses"
                />
                Possui uma reserva financeira para mais de 12 meses
              </label>
            </Checkbox>
            <Checkbox>
              <label>
                <input
                  type="radio"
                  ref={register}
                  name="field[44]"
                  value="Não possui familiares ou familiares não possuem renda"
                />
                Não possui familiares ou familiares não possuem renda
              </label>
            </Checkbox>

            <Error>{errors.financial?.message}</Error>
          </Options>

          <Options>
            <legend>Como irá se manter financeiramente durante o curso?</legend>

            <Checkbox>
              <label>
                <input
                  type="radio"
                  ref={register}
                  name="field[51]"
                  value="Tenho um bom dinheiro guardado"
                />
                Tenho um bom dinheiro guardado
              </label>
            </Checkbox>
            <Checkbox>
              <label>
                <input
                  type="radio"
                  ref={register}
                  name="field[51]"
                  value="Minha família vai me ajudar neste período"
                />
                Minha família vai me ajudar neste período
              </label>
            </Checkbox>
            <Checkbox>
              <label>
                <input
                  type="radio"
                  ref={register}
                  name="field[51]"
                  value="Tenho um trabalho/emprego fixo que não conflita com o horário"
                />
                Tenho um trabalho/emprego fixo que não conflita com o horário
              </label>
            </Checkbox>
            <Checkbox>
              <label>
                <input
                  type="radio"
                  ref={register}
                  name="field[51]"
                  value="Vou fazer trabalhos temporários para me sustentar"
                />
                Vou fazer trabalhos temporários para me sustentar
              </label>
            </Checkbox>

            <Error>{errors.howToStay?.message}</Error>
          </Options>

          <Options>
            <legend>Sua família apoia sua decisão de estudar na Kenzie?</legend>

            <Checkbox>
              <label>
                <input
                  type="radio"
                  ref={register}
                  name="field[46]"
                  value="Sim, já conversamos bem sobre a Kenzie"
                />
                Sim, já conversamos bem sobre a Kenzie
              </label>
            </Checkbox>
            <Checkbox>
              <label>
                <input
                  type="radio"
                  ref={register}
                  name="field[46]"
                  value="Sim, mas não aprofundei o assunto"
                />
                Sim, mas não aprofundei o assunto
              </label>
            </Checkbox>
            <Checkbox>
              <label>
                <input
                  type="radio"
                  ref={register}
                  name="field[46]"
                  value="Sabem que estou participando de um processo seletivo"
                />
                Sabem que estou participando de um processo seletivo
              </label>
            </Checkbox>
            <Checkbox>
              <label>
                <input
                  type="radio"
                  ref={register}
                  name="field[46]"
                  value="Não possuo esse apoio"
                />
                Não possuo esse apoio
              </label>
            </Checkbox>
            <Checkbox>
              <label>
                <input
                  type="radio"
                  ref={register}
                  name="field[46]"
                  value="Não conversei com familiares"
                />
                Não conversei com familiares
              </label>
            </Checkbox>

            <Error>{errors.family?.message}</Error>
          </Options>

          {Object.keys(errors).length !== 0 && (
            <p>Preencha todos os campos obrigatórios</p>
          )}

          <Button>Continuar</Button>
        </Form>
      </Container>
    </>
  );
};

export default DescriptiveQuestions;
